import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d084f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "city-wrapper" }
const _hoisted_3 = { class: "filter-header" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "city-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://live-cms-travel.oss-cn-zhangjiakou.aliyuncs.com/default_head.png",
  style: {"width":"30px","margin-right":"4px"}
}, null, -1))

import { MenuOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
import useCMS from "../hooks/useCMS";
import useJump from "../hooks/useJump";
import Cookies from "js-cookie";
import { logout } from "../utils";
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { getCityList } from "@/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const data = useCMS(1, 11);
const jump = useJump();

const token = Cookies.get("cms_token");
const username = Cookies.get("username");

const router = useRouter();
const geo = ref("石家庄");
const cityList = ref<any[]>([]);
const cityLogo = ref([
  {
    label: "ABCDEF",
    value: "A,B,C,D,E,F",
  },
  {
    label: "GHJ",
    value: "G,H,J",
  },
  {
    label: "KLMN",
    value: "K,L,M,N",
  },
  {
    label: "PQRSTW",
    value: "P,Q,R,S,T,W",
  },
  {
    label: "XYZ",
    value: "X,Y,Z",
  },
]);
const activeIndex = ref(0);

const toMy = () => {
  router.push("/my");
};

const toIntegralCenter=()=>{
  router.push("/integralCenter");
}

const toUpdatePwd = () => {
  router.push("/updatePassword");
};

const updateMobile = () => {
  router.push("/updateMobile");
};

const BMapGL = (window as any).BMapGL;
const geolocation = new BMapGL.Geolocation();

onMounted(() => {
  geolocation.getCurrentPosition(function (r: any) {
    if (geolocation.getStatus() == window.BMAP_STATUS_SUCCESS) {
      console.log(r);
      Cookies.set("Travel_location", JSON.stringify(r.point));
      geo.value = r.address.city;
    }
  });
  getList(cityLogo.value[0].value);
});
const getList = (first: string) => {
  getCityList({ first }).then((res: any) => {
    console.log("res", res);
    cityList.value = res.data;
  });
};
const checkCityLogo = (item: any, i: number) => {
  activeIndex.value = i;
  getList(item.value);
};
const changeCityName = (item: any) => {
  geo.value = item.shortname;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createBlock(_component_a_layout_header, { class: "header" }, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: require('@/assets/images/common/logo.png')
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        class: "dropdown",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createTextVNode(_toDisplayString(geo.value) + " ", 1),
        _createVNode(_unref(CaretDownOutlined)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityLogo.value, (item, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass({ active: activeIndex.value === i }),
                onClick: ($event: any) => (checkCityLogo(item, i))
              }, _toDisplayString(item.label), 11, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.letter
              }, [
                _createElementVNode("span", null, _toDisplayString(item.letter), 1),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (city) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: city.id,
                      onClick: ($event: any) => (changeCityName(city))
                    }, _toDisplayString(city.shortname), 9, _hoisted_6))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_a_menu, {
        mode: "horizontal",
        class: "p-menu"
      }, {
        overflowedIndicator: _withCtx(() => [
          _createVNode(_unref(MenuOutlined))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item) => {
            return (_openBlock(), _createBlock(_component_a_menu_item, {
              key: item.id,
              onClick: ($event: any) => (
          _unref(jump)(
            !item.jumpUrl || item.jumpUrl.startsWith('/')
              ? item.jumpUrl
              : '/sub' + item.sort
          )
        )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      (_unref(token))
        ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { onClick: toMy }, {
                    default: _withCtx(() => [
                      _createTextVNode("个人中心")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { onClick: toUpdatePwd }, {
                    default: _withCtx(() => [
                      _createTextVNode("修改密码")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { onClick: _unref(logout) }, {
                    default: _withCtx(() => [
                      _createTextVNode("退出登录")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "user",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_unref(username)), 1)
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "login-register",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("登录")
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, {
              type: "vertical",
              class: "divider"
            }),
            _createVNode(_component_router_link, {
              to: "/register",
              class: "login-register"
            }, {
              default: _withCtx(() => [
                _createTextVNode("注册")
              ]),
              _: 1
            })
          ], 64))
    ]),
    _: 1
  }))
}
}

})